"use client";

import { OPEN_PUBLIC_CHAT_EVENT } from "@/lib/chat/open-public-chat";
import { useEffect } from "react";
import { DeferredSearchDialog } from "@/components/search/deferred-search-dialog";
import { ErrorBoundary } from "@/components/error/error-boundary";
import {
  PublicSearchIconTrigger,
  PublicSearchTrigger,
} from "@/components/search/public-search-trigger";
import {
  SearchProvider,
  useSearchContext,
} from "@/components/search/search-context";
import { PublicChatWidget } from "@/components/support/public-chat-widget";
import {
  HIDDEN_BESIDE_HERO_ASK,
  HIDDEN_BESIDE_LISTING_SEARCH,
} from "@/components/layout/hero-ask-visibility";
import { cn } from "@/lib/utils";

export function PublicHeaderEnhancements() {
  return (
    <SearchProvider context="public">
      <div className={cn("hidden w-full max-w-md min-[1360px]:block [:root[data-ask-panel=open]_&]:hidden", HIDDEN_BESIDE_HERO_ASK, HIDDEN_BESIDE_LISTING_SEARCH)}>
        <PublicSearchTrigger className="w-full" />
      </div>
      <div className={cn("block min-[1360px]:hidden [:root[data-ask-panel=open]_&]:hidden", HIDDEN_BESIDE_HERO_ASK, HIDDEN_BESIDE_LISTING_SEARCH)}>
        <PublicSearchIconTrigger />
      </div>
      <DeferredSearchDialog />
      <ErrorBoundary
        label="public-chat-widget"
        fallback={null}
      >
        <PublicChatWidget />
      </ErrorBoundary>
      <PublicChatEventBridge />
    </SearchProvider>
  );
}

function PublicChatEventBridge() {
  const { openPublicChat } = useSearchContext();
  useEffect(() => {
    function handleOpenChat(event: Event) {
      if (!(event instanceof CustomEvent)) return;
      const message: unknown = event.detail;
      if (typeof message !== "string" || !message) return;
      openPublicChat(message);
    }

    window.addEventListener(OPEN_PUBLIC_CHAT_EVENT, handleOpenChat);
    return () => {
      window.removeEventListener(OPEN_PUBLIC_CHAT_EVENT, handleOpenChat);
    };
  }, [openPublicChat]);
  return null;
}
